<template>
  <div class="phoneTable">
    <div
      style="
        display: flex;
        align-items: center;
        height: 32px;
        margin: 16px 0 20px 0;
      "
    >
      <div style="margin-right:20px">
        <el-select
          size="small"
          v-model="partitionval"
          placeholder="请选择总监/区域"
          clearable
        >
          <el-option
            v-for="item in partition"
            :key="item.name"
            :value="item.staffId"
            :label="
              item.areaName
                ? `${item.staffName}-${item.areaName}`
                : item.staffName
            "
          >
          </el-option>
        </el-select>
      </div>
      <div style="display: flex">
        <el-button
          :type="dateType == '01' ? 'primary' : 'default'"
          size="small"
          @click="ClickDateType('01')"
          >今日</el-button
        >
        <el-button
          :type="dateType == '03' ? 'primary' : 'default'"
          size="small"
          @click="ClickDateType('03')"
          >本周</el-button
        >
        <el-button
          :type="dateType == '05' ? 'primary' : 'default'"
          size="small"
          @click="ClickDateType('05')"
          >本月</el-button
        >
      </div>
      <div class="el-date-time" style="margin-right: 0">
        <el-date-picker
          style="flex: 1;"
          v-model="valueTime"
          type="daterange"
          value-format="timestamp"
          size="small"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="['00:00:00', '23:59:59']"
        >
        </el-date-picker>
      </div>
      <span style="color: #20A0FF; font-size: 14px; margin-left: 20px; cursor: pointer;" @click="addTimePicker">{{addTimeText}}</span>
      <div class="el-date-time" style="margin-right: 0">
        <el-date-picker
          style="flex: 1;"
          v-model="thanValueTime"
          type="daterange"
          value-format="timestamp"
          size="small"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="['00:00:00', '23:59:59']"
          v-if="addTime"
          @change="handleCurrentChange"
          >
        </el-date-picker>
      </div>
      <span @click="addTimeCancle" v-if="addTime == true"><img src="../../../../assets/images/home/-s-zy_ico_close.png" class="close_img"></span>
      <div>
        <div class="btnType3" @click="handleCurrentChange">
          <i class="el-icon-search"></i>查询
        </div>
      </div>
      <el-button
        style="margin-left: 20px"
        size="small"
        type="success"
        icon="el-icon-download"
        :loading="exportExcelLoading"
        @click="exportExcel()"
        >导出Excel</el-button
      >
    </div>
    <el-table
      max-height="450"
      :data="tableData"
      border
      v-loading="phoneTableLoading"
      style="width: 100%"
    >
      <template slot="empty">
        <div class="table_empty">
          <img
            src="../../../../assets/images/tjsjtb.png"
            style="width:200px;height:100px"
            alt=""
          />
          <span style="font-size:12px;line-height:12px;padding-left:12px"
            >暂无数据</span
          >
        </div>
      </template>
      <el-table-column label="排序  " type="index" align="center" width="70">
        <template slot-scope="{ $index }">
          <div class="numBG_1" v-if="$index === 0">1</div>
          <div class="numBG_2" v-else-if="$index === 1">2</div>
          <div class="numBG_3" v-else-if="$index === 2">3</div>
          <div v-else>{{ $index + 1 }}</div>
        </template>
      </el-table-column>
      <el-table-column 
        prop="storeName"
        align="center" 
        label="门店名称"
      >
      </el-table-column>
      <el-table-column
        prop="inquiryNum.chooseData"
        label="询价量"
        align="center"
        sortable
      >
        <template slot-scope="scope">
          <span>{{ scope.row.inquiryNum.chooseData }}</span>
          <div v-if="tableSHowThan == true">
            <div v-if="scope.row.inquiryNum.thanUp == '00'" class="equationBlue" ><img src="../../../../assets/images/home/951@2x.png" style="width: 8px">{{ scope.row.inquiryNum.thanData }}%</div>
            <div v-else-if="scope.row.inquiryNum.thanUp == '01'" class="equationGreen"><img src="../../../../assets/images/home/icon_shqs_@2x.png" style="width: 8px">{{ scope.row.inquiryNum.thanData }}%</div>
            <div v-else-if="scope.row.inquiryNum.thanUp == '02'" class="equationRed"><img src="../../../../assets/images/home/icon_xjqs_@2x.png" style="width: 8px">{{ scope.row.inquiryNum.thanData }}%</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="countingOpenCount.chooseData"
        align="center"
        sortable
        min-width="100px"
      >
      <template slot="header">
          <div class="img-el-heard">
            <div>换购开口量</div>
            <div>
              <el-tooltip
                class="item"
                effect="dark"
                content="参与换购活动时完成开口的订单量"
                placement="top"
              >
                <img
                  src="../../../../assets/images/home/ico_ts_red_.png"
                  width="14px"
                  height="14px"
                  alt=""
                />
              </el-tooltip>
            </div>
          </div>
        </template>
        <template slot-scope="scope">
          <span>{{ scope.row.countingOpenCount.chooseData }}</span>
          <div v-if="tableSHowThan == true">
            <div v-if="scope.row.countingOpenCount.thanUp == '00'" class="equationBlue" ><img src="../../../../assets/images/home/951@2x.png" style="width: 8px">{{ scope.row.countingOpenCount.thanData }}%</div>
            <div v-else-if="scope.row.countingOpenCount.thanUp == '01'" class="equationGreen"><img src="../../../../assets/images/home/icon_shqs_@2x.png" style="width: 8px">{{ scope.row.countingOpenCount.thanData }}%</div>
            <div v-else-if="scope.row.countingOpenCount.thanUp == '02'" class="equationRed"><img src="../../../../assets/images/home/icon_xjqs_@2x.png" style="width: 8px">{{ scope.row.countingOpenCount.thanData }}%</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="countingOpenRate.chooseData"
        align="center"
        sortable
        min-width="100px"
      >
      <template slot="header">
          <div class="img-el-heard">
            <div>换购开口率</div>
            <div>
              <el-tooltip
                class="item"
                effect="dark"
                content="换购开口量/询价量*100%"
                placement="top"
              >
                <img
                  src="../../../../assets/images/home/ico_ts_red_.png"
                  width="14px"
                  height="14px"
                  alt=""
                />
              </el-tooltip>
            </div>
          </div>
        </template>
        <template slot-scope="scope">
          <span>{{ scope.row.countingOpenRate.chooseData }}%</span>
          <div v-if="tableSHowThan == true">
            <div v-if="scope.row.countingOpenRate.thanUp == '00'" class="equationBlue" ><img src="../../../../assets/images/home/951@2x.png" style="width: 8px">{{ scope.row.countingOpenRate.thanData }}%</div>
            <div v-else-if="scope.row.countingOpenRate.thanUp == '01'" class="equationGreen"><img src="../../../../assets/images/home/icon_shqs_@2x.png" style="width: 8px">{{ scope.row.countingOpenRate.thanData }}%</div>
            <div v-else-if="scope.row.countingOpenRate.thanUp == '02'" class="equationRed"><img src="../../../../assets/images/home/icon_xjqs_@2x.png" style="width: 8px">{{ scope.row.countingOpenRate.thanData }}%</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="dealNum.chooseData" label="成交量" align="center" sortable>
        <template slot-scope="scope">
          <span>{{ scope.row.dealNum.chooseData }}</span>
          <div v-if="tableSHowThan == true">
            <div v-if="scope.row.dealNum.thanUp == '00'" class="equationBlue" ><img src="../../../../assets/images/home/951@2x.png" style="width: 8px">{{ scope.row.dealNum.thanData }}%</div>
            <div v-else-if="scope.row.dealNum.thanUp == '01'" class="equationGreen"><img src="../../../../assets/images/home/icon_shqs_@2x.png" style="width: 8px">{{ scope.row.dealNum.thanData }}%</div>
            <div v-else-if="scope.row.dealNum.thanUp == '02'" class="equationRed"><img src="../../../../assets/images/home/icon_xjqs_@2x.png" style="width: 8px">{{ scope.row.dealNum.thanData }}%</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="renewNum.chooseData" label="以旧换新量" align="center" sortable min-width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.renewNum.chooseData }}</span>
          <div v-if="tableSHowThan == true">
            <div v-if="scope.row.renewNum.thanUp == '00'" class="equationBlue" ><img src="../../../../assets/images/home/951@2x.png" style="width: 8px">{{ scope.row.renewNum.thanData }}%</div>
            <div v-else-if="scope.row.renewNum.thanUp == '01'" class="equationGreen"><img src="../../../../assets/images/home/icon_shqs_@2x.png" style="width: 8px">{{ scope.row.renewNum.thanData }}%</div>
            <div v-else-if="scope.row.renewNum.thanUp == '02'" class="equationRed"><img src="../../../../assets/images/home/icon_xjqs_@2x.png" style="width: 8px">{{ scope.row.renewNum.thanData }}%</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="renewSubsidyNum.chooseData" label="换购成交" align="center" sortable min-width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.renewSubsidyNum.chooseData }}</span>
          <div v-if="tableSHowThan == true">
            <div v-if="scope.row.renewSubsidyNum.thanUp == '00'" class="equationBlue" ><img src="../../../../assets/images/home/951@2x.png" style="width: 8px">{{ scope.row.renewSubsidyNum.thanData }}%</div>
            <div v-else-if="scope.row.renewSubsidyNum.thanUp == '01'" class="equationGreen"><img src="../../../../assets/images/home/icon_shqs_@2x.png" style="width: 8px">{{ scope.row.renewSubsidyNum.thanData }}%</div>
            <div v-else-if="scope.row.renewSubsidyNum.thanUp == '02'" class="equationRed"><img src="../../../../assets/images/home/icon_xjqs_@2x.png" style="width: 8px">{{ scope.row.renewSubsidyNum.thanData }}%</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="renewAckRate.chooseData"
        align="center"
        sortable
        min-width="100px"
      >
        <template slot="header">
          <div class="img-el-heard">
            <div>换购成交率</div>
            <div>
              <el-tooltip
                class="item"
                effect="dark"
                content="换购补贴量/询价量*100%"
                placement="top"
              >
                <img
                  src="../../../../assets/images/home/ico_ts_red_.png"
                  width="14px"
                  height="14px"
                  alt=""
                />
              </el-tooltip>
            </div>
          </div>
        </template>
        <template slot-scope="scope">
          <span>{{ scope.row.renewAckRate.chooseData }}%</span>
          <div v-if="tableSHowThan == true">
            <div v-if="scope.row.renewAckRate.thanUp == '00'" class="equationBlue" ><img src="../../../../assets/images/home/951@2x.png" style="width: 8px">{{ scope.row.renewAckRate.thanData }}%</div>
            <div v-else-if="scope.row.renewAckRate.thanUp == '01'" class="equationGreen"><img src="../../../../assets/images/home/icon_shqs_@2x.png" style="width: 8px">{{ scope.row.renewAckRate.thanData }}%</div>
            <div v-else-if="scope.row.renewAckRate.thanUp == '02'" class="equationRed"><img src="../../../../assets/images/home/icon_xjqs_@2x.png" style="width: 8px">{{ scope.row.renewAckRate.thanData }}%</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="renewSubsidyRate.chooseData" label="换购补贴占比" align="center" sortable min-width="110px">
        <template slot="header">
          <div class="img-el-heard">
            <div>换购补贴占比</div>
            <div>
              <el-tooltip
                class="item"
                effect="dark"
                content="换购补贴量/成交量*100%"
                placement="top"
              >
                <img
                  src="../../../../assets/images/home/ico_ts_red_.png"
                  width="14px"
                  height="14px"
                  alt=""
                />
              </el-tooltip>
            </div>
          </div>
        </template>
        <template slot-scope="scope">
          <span>{{ scope.row.renewSubsidyRate.chooseData }}%</span>
          <div v-if="tableSHowThan == true">
            <div v-if="scope.row.renewSubsidyRate.thanUp == '00'" class="equationBlue" ><img src="../../../../assets/images/home/951@2x.png" style="width: 8px">{{ scope.row.renewSubsidyRate.thanData }}%</div>
            <div v-else-if="scope.row.renewSubsidyRate.thanUp == '01'" class="equationGreen"><img src="../../../../assets/images/home/icon_shqs_@2x.png" style="width: 8px">{{ scope.row.renewSubsidyRate.thanData }}%</div>
            <div v-else-if="scope.row.renewSubsidyRate.thanUp == '02'" class="equationRed"><img src="../../../../assets/images/home/icon_xjqs_@2x.png" style="width: 8px">{{ scope.row.renewSubsidyRate.thanData }}%</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="dealProfit.chooseData" label="回收毛利" align="center" sortable min-width="100px">
        <template slot="header">
          <div class="img-el-heard">
            <div>回收毛利</div>
            <div>
              <el-tooltip class="item" effect="dark" content="仅统计完成换购的回收订单的回收毛利" placement="top">
                <img src="../../../../assets/images/home/ico_ts_red_.png" width="14px" height="14px" alt=""/>
              </el-tooltip>
            </div>
          </div>
        </template>
        <template slot-scope="scope">
          <span>{{ scope.row.dealProfit.chooseData }}</span>
          <div v-if="tableSHowThan == true">
            <div v-if="scope.row.dealProfit.thanUp == '00'" class="equationBlue" ><img src="../../../../assets/images/home/951@2x.png" style="width: 8px">{{ scope.row.dealProfit.thanData }}%</div>
            <div v-else-if="scope.row.dealProfit.thanUp == '01'" class="equationGreen"><img src="../../../../assets/images/home/icon_shqs_@2x.png" style="width: 8px">{{ scope.row.dealProfit.thanData }}%</div>
            <div v-else-if="scope.row.dealProfit.thanUp == '02'" class="equationRed"><img src="../../../../assets/images/home/icon_xjqs_@2x.png" style="width: 8px">{{ scope.row.dealProfit.thanData }}%</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="cutPrice.chooseData"
        label="压价金额"
        align="center"
        sortable
        min-width="100px"
      >
        <template slot="header">
          <div class="img-el-heard">
            <div>压价金额</div>
            <div>
              <el-tooltip class="item" effect="dark" content="仅统计完成换购的回收订单的回收压价" placement="top">
                <img src="../../../../assets/images/home/ico_ts_red_.png" width="14px" height="14px" alt=""/>
              </el-tooltip>
            </div>
          </div>
        </template>
        <template slot-scope="scope">
          <span>{{ scope.row.cutPrice.chooseData }}</span>
          <div v-if="tableSHowThan == true">
            <div v-if="scope.row.cutPrice.thanUp == '00'" class="equationBlue" ><img src="../../../../assets/images/home/951@2x.png" style="width: 8px">{{ scope.row.cutPrice.thanData }}%</div>
            <div v-else-if="scope.row.cutPrice.thanUp == '01'" class="equationGreen"><img src="../../../../assets/images/home/icon_shqs_@2x.png" style="width: 8px">{{ scope.row.cutPrice.thanData }}%</div>
            <div v-else-if="scope.row.cutPrice.thanUp == '02'" class="equationRed"><img src="../../../../assets/images/home/icon_xjqs_@2x.png" style="width: 8px">{{ scope.row.cutPrice.thanData }}%</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="netRebateAmount.chooseData" label="公司净利" align="center" sortable min-width="100px">
        <template slot="header">
          <div class="img-el-heard">
            <div>公司净利</div>
            <div>
              <el-tooltip class="item" effect="dark" content="仅统计完成换购的回收订单的公司净利" placement="top">
                <img src="../../../../assets/images/home/ico_ts_red_.png" width="14px" height="14px" alt=""/>
              </el-tooltip>
            </div>
          </div>
        </template>
        <template slot-scope="scope">
          <span>{{ scope.row.netRebateAmount.chooseData }}</span>
          <div v-if="tableSHowThan == true">
            <div v-if="scope.row.netRebateAmount.thanUp == '00'" class="equationBlue" ><img src="../../../../assets/images/home/951@2x.png" style="width: 8px">{{ scope.row.netRebateAmount.thanData }}%</div>
            <div v-else-if="scope.row.netRebateAmount.thanUp == '01'" class="equationGreen"><img src="../../../../assets/images/home/icon_shqs_@2x.png" style="width: 8px">{{ scope.row.netRebateAmount.thanData }}%</div>
            <div v-else-if="scope.row.netRebateAmount.thanUp == '02'" class="equationRed"><img src="../../../../assets/images/home/icon_xjqs_@2x.png" style="width: 8px">{{ scope.row.netRebateAmount.thanData }}%</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="renewProductSellPrice.chooseData" label="换购销售额" align="center" sortable min-width="100px">
        <template slot="header">
          <div class="img-el-heard">
            <div>换购销售额</div>
            <div>
              <el-tooltip class="item" effect="dark" content="换购销售额：换购商品的销售价总和，不含赠品" placement="top">
                <img src="../../../../assets/images/home/ico_ts_red_.png" width="14px" height="14px" alt=""/>
              </el-tooltip>
            </div>
          </div>
        </template>
        <template slot-scope="scope">
          <span>{{ scope.row.renewProductSellPrice.chooseData }}</span>
          <div v-if="tableSHowThan == true">
            <div v-if="scope.row.renewProductSellPrice.thanUp == '00'" class="equationBlue" ><img src="../../../../assets/images/home/951@2x.png" style="width: 8px">{{ scope.row.renewProductSellPrice.thanData }}%</div>
            <div v-else-if="scope.row.renewProductSellPrice.thanUp == '01'" class="equationGreen"><img src="../../../../assets/images/home/icon_shqs_@2x.png" style="width: 8px">{{ scope.row.renewProductSellPrice.thanData }}%</div>
            <div v-else-if="scope.row.renewProductSellPrice.thanUp == '02'" class="equationRed"><img src="../../../../assets/images/home/icon_xjqs_@2x.png" style="width: 8px">{{ scope.row.renewProductSellPrice.thanData }}%</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="renewProductSubsidyPrice.chooseData" label="换购补贴" align="center" sortable min-width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.renewProductSubsidyPrice.chooseData }}</span>
          <div v-if="tableSHowThan == true">
            <div v-if="scope.row.renewProductSubsidyPrice.thanUp == '00'" class="equationBlue" ><img src="../../../../assets/images/home/951@2x.png" style="width: 8px">{{ scope.row.renewProductSubsidyPrice.thanData }}%</div>
            <div v-else-if="scope.row.renewProductSubsidyPrice.thanUp == '01'" class="equationGreen"><img src="../../../../assets/images/home/icon_shqs_@2x.png" style="width: 8px">{{ scope.row.renewProductSubsidyPrice.thanData }}%</div>
            <div v-else-if="scope.row.renewProductSubsidyPrice.thanUp == '02'" class="equationRed"><img src="../../../../assets/images/home/icon_xjqs_@2x.png" style="width: 8px">{{ scope.row.renewProductSubsidyPrice.thanData }}%</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="realSellPrice.chooseData" label="换购实售额" align="center" sortable min-width="100px">
        <!-- <template slot="header">
          <div class="img-el-heard">
            <div>换购实售额</div>
            <div>
              <el-tooltip class="item" effect="dark" content="换购实售额=商品售价-换购补贴，不含赠品" placement="top">
                <img src="../../../../assets/images/home/ico_ts_red_.png" width="14px" height="14px" alt=""/>
              </el-tooltip>
            </div>
          </div>
        </template> -->
        <template slot-scope="scope">
          <span>{{ scope.row.realSellPrice.chooseData }}</span>
          <div v-if="tableSHowThan == true">
            <div v-if="scope.row.realSellPrice.thanUp == '00'" class="equationBlue" ><img src="../../../../assets/images/home/951@2x.png" style="width: 8px">{{ scope.row.realSellPrice.thanData }}%</div>
            <div v-else-if="scope.row.realSellPrice.thanUp == '01'" class="equationGreen"><img src="../../../../assets/images/home/icon_shqs_@2x.png" style="width: 8px">{{ scope.row.realSellPrice.thanData }}%</div>
            <div v-else-if="scope.row.realSellPrice.thanUp == '02'" class="equationRed"><img src="../../../../assets/images/home/icon_xjqs_@2x.png" style="width: 8px">{{ scope.row.realSellPrice.thanData }}%</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="renewProductCost.chooseData" label="换购成本" align="center" sortable min-width="100px">
         <template slot-scope="scope">
          <span>{{ scope.row.renewProductCost.chooseData }}</span>
          <div v-if="tableSHowThan == true">
            <div v-if="scope.row.renewProductCost.thanUp == '00'" class="equationBlue" ><img src="../../../../assets/images/home/951@2x.png" style="width: 8px">{{ scope.row.renewProductCost.thanData }}%</div>
            <div v-else-if="scope.row.renewProductCost.thanUp == '01'" class="equationGreen"><img src="../../../../assets/images/home/icon_shqs_@2x.png" style="width: 8px">{{ scope.row.renewProductCost.thanData }}%</div>
            <div v-else-if="scope.row.renewProductCost.thanUp == '02'" class="equationRed"><img src="../../../../assets/images/home/icon_xjqs_@2x.png" style="width: 8px">{{ scope.row.renewProductCost.thanData }}%</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="renewRebate.chooseData" label="换购利润" align="center" sortable min-width="100px">
        <template slot="header">
          <div class="img-el-heard">
            <div>换购利润</div>
            <div>
              <el-tooltip class="item" effect="dark" content="订单换购利润=换购商品实售价-换购商品成本，不含赠品" placement="top">
                <img src="../../../../assets/images/home/ico_ts_red_.png" width="14px" height="14px" alt=""/>
              </el-tooltip>
            </div>
          </div>
        </template>
        <template slot-scope="scope">
          <span>{{ scope.row.renewRebate.chooseData }}</span>
          <div v-if="tableSHowThan == true">
            <div v-if="scope.row.renewRebate.thanUp == '00'" class="equationBlue" ><img src="../../../../assets/images/home/951@2x.png" style="width: 8px">{{ scope.row.renewRebate.thanData }}%</div>
            <div v-else-if="scope.row.renewRebate.thanUp == '01'" class="equationGreen"><img src="../../../../assets/images/home/icon_shqs_@2x.png" style="width: 8px">{{ scope.row.renewRebate.thanData }}%</div>
            <div v-else-if="scope.row.renewRebate.thanUp == '02'" class="equationRed"><img src="../../../../assets/images/home/icon_xjqs_@2x.png" style="width: 8px">{{ scope.row.renewRebate.thanData }}%</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="renewRebateRate.chooseData" label="换购利润率" align="center" sortable min-width="100px">
        <template slot="header">
          <div class="img-el-heard">
            <div>换购利润率</div>
            <div>
              <el-tooltip class="item" effect="dark" content="换购利润/实售价*100%" placement="top">
                <img src="../../../../assets/images/home/ico_ts_red_.png" width="14px" height="14px" alt=""/>
              </el-tooltip>
            </div>
          </div>
        </template>
        <template slot-scope="scope">
          <span>{{ scope.row.renewRebateRate.chooseData }}%</span>
          <div v-if="tableSHowThan == true">
            <div v-if="scope.row.renewRebateRate.thanUp == '00'" class="equationBlue" ><img src="../../../../assets/images/home/951@2x.png" style="width: 8px">{{ scope.row.renewRebateRate.thanData }}%</div>
            <div v-else-if="scope.row.renewRebateRate.thanUp == '01'" class="equationGreen"><img src="../../../../assets/images/home/icon_shqs_@2x.png" style="width: 8px">{{ scope.row.renewRebateRate.thanData }}%</div>
            <div v-else-if="scope.row.renewRebateRate.thanUp == '02'" class="equationRed"><img src="../../../../assets/images/home/icon_xjqs_@2x.png" style="width: 8px">{{ scope.row.renewRebateRate.thanData }}%</div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-dialog
      :visible="recVisible"
      @close="recVisible = false"
      title="店员交易数据"
      width="1136px"
    >
      <div style="display: flex; width: 100%;height:32px;margin-bottom:20px">
        <div style="display: flex;">
          <div style="display: flex; align-items: center;margin-right:20px">
            <div style="width: 60px">店员名称</div>
            <el-select
              size="small"
              v-model="storeIdValue"
              clearable
              placeholder="请选择店员"
              @change="handleChangeInquiry"
            >
              <el-option
                v-for="item in storeList"
                :key="item.staffId"
                :label="item.staffName"
                :value="item.staffId"
              ></el-option>
            </el-select>
          </div>
          <el-button
            :type="dateTypeDia == '01' ? 'primary' : 'default'"
            size="small"
            @click="ClickDateTypeDia('01')"
            >今日</el-button
          >
          <el-button
            :type="dateTypeDia == '03' ? 'primary' : 'default'"
            size="small"
            @click="ClickDateTypeDia('03')"
            >本周</el-button
          >
          <el-button
            :type="dateTypeDia == '05' ? 'primary' : 'default'"
            size="small"
            @click="ClickDateTypeDia('05')"
            >本月</el-button
          >
        </div>
        <div style="display: flex;">
          <div class="el-date-time">
            <el-date-picker
              size="small"
              v-model="valueTimeDia"
              type="daterange"
              value-format="timestamp"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </div>
          <div>
            <div class="btnType3" @click="getStaffRank">
              <i class="el-icon-search"></i>查询
            </div>
          </div>
        </div>
      </div>
      <div style="margin-bottom: 20px">
        <el-table
          max-height="550"
          :data="tableDataDia"
          v-loading="staffLoading"
          border
          style="width: 100%"
        >
          <el-table-column type="index" label="序号" align="center" width="50">
          </el-table-column>
          <el-table-column
            prop="staffName"
            label="店员"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="inquiry"
            label="询价"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="deal"
            label="成交量"
            align="center"
          ></el-table-column>
          <el-table-column label="成交率" align="center">
            <template slot-scope="{ row }"> {{ row.dealRate }}% </template>
          </el-table-column>
          <el-table-column
            prop="dealAmount"
            label="累计成交额"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="grossProfit"
            label="毛利"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="depreciate"
            label="差异订单量"
            align="center"
          ></el-table-column>
        </el-table>
      </div>
    </el-dialog> -->

    <!-- <el-dialog
      :visible="storeVisible"
      @close="storeVisible = false"
      title="门店成交订单分析"
      width="1136px"
    >
      <div style="display: flex; width: 100%;height:32px;margin-bottom: 20px">
        <div style="display: flex;">
          <el-button
            :type="StoreDia == '01' ? 'primary' : 'default'"
            size="small"
            @click="ClickStoreDia('01')"
            >今日</el-button
          >
          <el-button
            :type="StoreDia == '03' ? 'primary' : 'default'"
            size="small"
            @click="ClickStoreDia('03')"
            >本周</el-button
          >
          <el-button
            :type="StoreDia == '05' ? 'primary' : 'default'"
            size="small"
            @click="ClickStoreDia('05')"
            >本月</el-button
          >
        </div>
        <div style="display: flex;align-items: center;">
          <div class="el-date-time">
            <el-date-picker
              size="small"
              v-model="ValueTimeStoreDia"
              type="daterange"
              value-format="timestamp"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </div>
          <div>
            <div class="btnType3" @click="getStoreNum(1)">
              <i class="el-icon-search"></i>查询
            </div>
          </div>
        </div>
      </div>
      <div style="margin-bottom: 20px">
        <el-table
          max-height="550"
          :data="tableDataDia2"
          border
          style="width: 100%"
          v-loading="dealLoading"
        >
          <el-table-column type="index" label="序号" align="center" width="50">
          </el-table-column>
          <el-table-column
            prop="orderNo"
            label="订单编号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="staffName"
            label="店员"
            align="center"
          ></el-table-column>
          <el-table-column label="旧机名称" align="center">
            <template slot-scope="{ row }">
              <span style="margin-right: 5px">{{ row.spec }}</span>
            </template>
          </el-table-column>
          <el-table-column label="最高报价" align="center">
            <template slot-scope="{ row }">
              <span style="margin-right: 5px">￥{{ row.maxPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="dealPrice" label="成交价/商家" align="center">
            <template slot-scope="{ row }">
              <span style="margin-right: 5px">￥{{ row.dealPrice }}</span
              >{{ row.dealMerchantName }}
            </template>
          </el-table-column>
          <el-table-column label="毛利" align="center">
            <template slot-scope="{ row }">
              <span>￥{{ row.dealProfit }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div style="float: right; margin: 20px 0">
          <el-pagination
            background
            :current-page="page.pageNum"
            :page-size="page.pageSize"
            layout="total, prev, pager, next,jumper"
            :total="page.total"
            class="el-pagination-c"
            @current-change="getStoreNum"
          />
        </div>
      </div>
    </el-dialog> -->
  </div>
</template>
<script>
import _api from "@/utils/request";
import { MessageBox } from "element-ui";
import TestUseVue from '../../../RecallOrder/componets/TestUse.vue';
export default {
  name: "newStoreTable",
  // props: ["xcxStaffId"],
  props: ["partition", "id"],
  data() {
    return {
      phoneTableLoading: false,
      staffLoading: false,
      dealLoading: false,
      valueTimeDia: "",
      ValueTimeStoreDia: "",
      dateTypeDia: "01",
      StoreDia: "01",
      storeVisible: false,
      storeId: "", //店员id
      storeIdValue: "", //弹窗id防止刚点击弹窗回显
      companyId: "", //商家id
      storeList: [],
      recVisible: false,
      valueTime: "",
      thanValueTime: [],
      orderType: "01",
      dateType: "01",
      tableData: [],
      tableDataDia: [],
      tableDataDia2: [],
      page: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
      },
      partitionval: "",
      addTime: false,
      addTimeText: '+添加对比时间',
      isThan: false,
      tableSHowThan: true,
      exportExcelLoading: false
    };
  },
  created() {
    // console.log(this.xcxStaffId, "父传子");
    // this.staffType = JSON.parse(localStorage.getItem("user")).staffType;
    this.handleCurrentChange();
  },
  watch: {
    // xcxStaffId() {
    //   console.log(this.xcxStaffId);
    // },
  },
  methods: {
    // 表格切换页面
    handleCurrentChange() {
      if (this.valueTime && this.valueTime.length) {
        this.dateType = "";
      } else if (!this.dateType) {
        this.dateType = "01";
      }
      if (this.isThan == false && this.valueTime) {
        this.tableSHowThan = false
      } else {
        this.tableSHowThan = true
      }
      if (this.dateType) {
        this.tableSHowThan = true
      }
      const baseRequest = {
        dateType: this.dateType, //	今日 01 本周：03，本月：05
        endTime: this.valueTime ? this.valueTime[1] : "",
        orderType: this.orderType, //	排序类别 累计询价（报价）排行：01 累计成交排行：02，毛利贡献排行：03
        startTime: this.valueTime ? this.valueTime[0] : "",
        xcxStaffId: this.partitionval,
        thanEndTime: this.thanValueTime ? this.thanValueTime[1] : "",
        thanStartTime: this.thanValueTime ? this.thanValueTime[0] : "",
        companyId: this.id,
      };
      this.phoneTableLoading = true;
      _api.getRenewStore(baseRequest).then((res) => {
        if (res.code === 1) {
          this.tableData = res.data;
        }
        this.phoneTableLoading = false;
      });
    },
    addTimePicker () {
      this.addTime = true
      this.addTimeText = '对比时间'
      this.isThan = true
    },
    addTimeCancle () {
      this.addTimeText = '+添加对比时间'
      this.addTime = false
      this.isThan = false
      this.tableSHowThan = true
      this.thanValueTime = []
    },
    ClickOrderType(val) {
      this.orderType = val;
      console.log(this.orderType);
      this.handleCurrentChange();
    },
    ClickDateType(val) {
      this.tableSHowThan = true
      this.valueTime = "";
      this.dateType = val;
      this.handleCurrentChange();
    },
    //店员交易数据切换年月日
    ClickDateTypeDia(val) {
      console.log("valueTimevalueTime");
      this.valueTimeDia = "";
      this.dateTypeDia = val;
      this.getStaffRank();
    },
    //////////////////////////////////////////
    // 累计数量弹窗
    ClickStoreDia(val) {
      this.ValueTimeStoreDia = "";
      this.StoreDia = val;
      this.getStoreNum(1);
      console.log(val);
    },
    ClickStoreDiaNum(row) {
      this.storeId = row.id;
      this.StoreDia = this.dateType;
      this.ValueTimeStoreDia = this.valueTime;
      this.getStoreNum();
      this.storeVisible = true;
      console.log(row, "累计数量弹窗");
    },
    //查询
    getStoreNum(val) {
      if (this.ValueTimeStoreDia && this.ValueTimeStoreDia.length) {
        this.StoreDia = "";
      } else if (!this.StoreDia) {
        this.StoreDia = "01";
      }
      const params = {
        dateType: this.StoreDia,
        storeId: this.storeId,
        startTime: this.ValueTimeStoreDia ? this.ValueTimeStoreDia[0] : "",
        endTime: this.ValueTimeStoreDia ? this.ValueTimeStoreDia[1] : "",
        pageNum: val ? val : this.page.pageNum,
        pageSize: this.page.pageSize,
      };
      this.dealLoading = true;
      _api.getOrderDeal(params).then((res) => {
        console.log(res);
        this.tableDataDia2 = res.data.records;
        this.page.total = res.data.total;
        console.log(this.page.total);
        this.dealLoading = false;
      });
    },
    exportExcel() {
      this.exportExcelLoading = true
      _api
        .getRenewStoreExcel({
          companyId: this.id,
          dateType: this.dateType, //	今日 01 本周：03，本月：05
          endTime: this.valueTime ? this.valueTime[1] : "",
          orderType: this.orderType, //	排序类别 累计询价（报价）排行：01 累计成交排行：02，毛利贡献排行：03
          startTime: this.valueTime ? this.valueTime[0] : "",
          xcxStaffId: this.partitionval,
          thanEndTime: this.thanValueTime ? this.thanValueTime[1] : "",
          thanStartTime: this.thanValueTime ? this.thanValueTime[0] : "",
        })
        .then((res) => {
          console.log(res);
          const content = res;
          const blob = new Blob([content]);

          let reader = new FileReader(); // 创建读取文件对象
          reader.addEventListener("loadend", () => {
            //
            try {
              let data = JSON.parse(reader.result);
              if (data.code === 0) {
                MessageBox.alert(data.msg, "错误提示", {
                  type: "error",
                });
              }
            } catch (err) {
              const fileName = "换购成交数据门店统计.xlsx";
              if ("download" in document.createElement("a")) {
                // 非IE下载
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
              } else {
                // IE10+下载
                navigator.msSaveBlob(blob, fileName);
              }
            }
          });
          reader.readAsText(blob, "utf-8"); // 设置读取的数据以及返回的数据类型为utf-8
          this.exportExcelLoading = false
        })
        .catch((err) => {
          this.exportExcelLoading = false
          console.log(err);
        });
    },
    //列表门店弹窗
    clickStoreTableDia(row) {
      console.log(row, "列表门店弹窗");
      this.storeId = row.id;
      this.storeIdValue = "";
      this.dateTypeDia = this.dateType;
      this.valueTimeDia = this.valueTime;
      this.getStoreList(row.id);
      this.getStaffRank();
      this.recVisible = true;
    },
    //店员下拉
    handleChangeInquiry(row) {
      console.log(row);
    },
    getStoreList(val) {
      const params = {
        storeId: val,
      };
      _api.getStaffList(params).then((res) => {
        console.log(res);
        this.storeList = res.data.records;
      });
    },
    //店员弹窗列表
    getStaffRank() {
      if (this.valueTimeDia && this.valueTimeDia.length) {
        this.dateTypeDia = "";
      } else if (!this.dateTypeDia) {
        this.dateTypeDia = "01";
      }
      const params = {
        dateType: this.dateTypeDia,
        endTime: this.valueTimeDia ? this.valueTimeDia[1] : "",
        orderType: this.orderType,
        staffName: this.staffName,
        startTime: this.valueTimeDia ? this.valueTimeDia[0] : "",
        staffId: this.storeIdValue,
        storeId: this.storeId,
      };
      this.staffLoading = true;
      _api.getStaffRankInStore(params).then((res) => {
        console.log(res);
        this.tableDataDia = res.data;
        this.staffLoading = false;
      });
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.el-date-time {
  /deep/ .el-input__inner {
    width: 250px !important;
  }
  margin: 0 20px;
  /deep/ .el-range-separator {
    width: 10% !important;
  }
}
.el-seach {
  margin-right: 50px;
  /deep/ .el-input--small .el-input__inner {
    height: 32px !important;
    line-height: 32px !important;
  }
  /deep/ .el-input__inner {
    width: 200px !important;
    border-radius: 18px !important;
  }
}

.phoneTable {
  .btn {
    box-shadow: 2px 1px 10px 0px rgba(63, 44, 245, 0.2);
    margin: 0px 10px 0px 0;
    text-align: center;
    cursor: pointer;
  }
  .btnType1 {
    background: #0981ff;
    color: white;
    height: 32px;
    background: #20a0ff;
    border-radius: 4px;
    font-size: 14px;
    font-family: FZLanTingHei-M-GBK;
    font-weight: 400;
    color: #ffffff;
    line-height: 32px;
    padding: 0 9px;
  }
  .btnType-after1 {
    padding: 0 9px;
    height: 32px;
    background: #ffffff;
    border: 1px solid #20a0ff;
    border-radius: 4px;
    font-size: 14px;
    font-family: FZLanTingHei-M-GBK;
    font-weight: 400;
    color: #20a0ff;
    line-height: 32px;
  }
  .btnType2 {
    min-width: 30px;
    flex: 0.3;
    height: 36px;
    background: #0981ff;
    color: white;
    line-height: 36px;
    border-radius: 18px;
  }
  .btnType-after2 {
    // width: 33%;
    min-width: 40px;
    flex: 0.3;
    height: 36px;
    background: #ffffff;
    color: #0981ff;
    line-height: 36px;
    border-radius: 18px;
  }
  .btnType4 {
    width: 70px;
    // flex: 0.3;
    height: 36px;
    background: #0981ff;
    color: white;
    line-height: 36px;
    border-radius: 18px;
  }
  .btnType-after3 {
    width: 70px;
    // flex: 0.3;
    height: 36px;
    background: #ffffff;
    color: #0981ff;
    line-height: 36px;
    border-radius: 18px;
  }
  .btnType3 {
    box-shadow: 2px 1px 10px 0px rgba(63, 44, 245, 0.2);
    text-align: center;
    cursor: pointer;
    width: 60px;
    height: 32px;
    line-height: 32px;
    background: #20a0ff;
    color: white;
    border-radius: 4px;
    margin-left: 20px;
    font-size: 14px;
  }
  .orderPagina {
    float: right;
    padding: 30px;
  }
  .numBG_1 {
    background-image: url("../../../../assets/images/imgAll/icon_01.png");
    background-size: 100%;
    color: white;
  }
  .numBG_2 {
    background-image: url("../../../../assets/images/imgAll/icon_02.png");
    background-size: 100%;
    color: white;
  }
  .numBG_3 {
    background-image: url("../../../../assets/images/imgAll/icon_03.png");
    background-size: 100%;
    color: white;
  }
  .el-button--default {
    //需要更改的按钮类型 type='default'
    background: #f9fbfd !important;
    border-color: #d9e6ff !important;
    color: #8492a6 !important;
  }
  //移入时按钮样式type='default'
  .el-button--default:hover {
    background: #fff !important;
    border-color: #45a3fc !important;
    color: #20a0ff !important;
    opacity: 0.8;
  }
  .el-button--primary {
    //需要更改的按钮类型 type='primary'
    background: #20a0ff !important;
    border-color: #20a0ff !important;
  }
  //移入时按钮样式 type='primary'
  .el-button--primary:hover {
    background: #20a0ff !important;
    border-color: #20a0ff !important;
    color: #fff !important;
    opacity: 0.8;
  }
  .Remarks {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1; //控制行数
    overflow: hidden;
  }
  .table_empty {
    padding: 30px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .img-el-heard {
    display: flex;
    justify-content: center;
    img {
      margin: 0px 0 -3px 3px;
    }
  }
  .equationBlue {
    color: #20A0FF;
  }
  .equationGreen {
    color: #49A915;
  }
  .equationRed {
    color: #FF4949;
  }
}
</style>
